const getReduxStoreReference = () => {
    const { store } = require('../../index');
    return store;
}

export const MARKET_TYPES = {
    UHC: 'UHC',
    OXFORD: 'OXFORD'
}
/** Function to get market type UHC/OXFORD */
export const getMarketType = () => {
    const { overall } = getReduxStoreReference().getState();
    // if (overall.appConfigDetails && overall.appConfigDetails.marketType === 'PRIME') {
        if (overall && overall.platform === 'PRIME') {
        return MARKET_TYPES.UHC;
    } else {
        return MARKET_TYPES.OXFORD;
    }
}

export const isUhcRenewals = () => {
    const { overall } = getReduxStoreReference().getState();
    if (
        overall.appConfigDetails &&
        // overall.appConfigDetails.marketType === "PRIME" &&
        overall.platform === "PRIME" &&
        (overall.isRenewals || overall.source === "renewal" || overall.source === "mmr")
    ) {
        return true;
    }
    return false;
}

export const getEligibleCountFromIbr = (renewalData) =>{
    if(renewalData){
        return renewalData.Ibr.group.primaryLocation.totalEligible;
    }
}

export const isOxfordRenewals = () => {
const { overall } = getReduxStoreReference().getState();
    if (
        overall.appConfigDetails &&
        overall.appConfigDetails.marketType === "CIRRUS" &&
        (overall.isRenewals || overall.source === "renewal")
    ) {
        return true;
    }
    return false;
}

export const isMmr = () => {
    const { overall } = getReduxStoreReference().getState();
    if (overall.source === 'mmr') {
        return true;
    }
    return false;
}

/** 
 * Function to check if the group is migrated for UHC & Oxford groups
 * Compares the case's effective date with the migratedCutOffDate from DB
 * If effective date is greater than migratedCutOffDate, it's a migrated group
 * @returns {boolean} true if migrated group, false otherwise
 */
export const isMigratedGroup = () => {
    const state = getReduxStoreReference().getState();
    const { overall, renewals } = state;
        
    const migratedCutOffDate = overall?.uhcStateConfig?.renewals?.migrationCutOffDate;
    const effectiveDate = renewals?.renewalCaseData?.effectiveDate;
    
    // If either value is missing, treat as non-migrated
    if (!migratedCutOffDate || !effectiveDate) {
        return false;
    }
    
    // Compare dates: if effectiveDate >= migratedCutOffDate, it's migrated
    const caseEffectiveDate = new Date(effectiveDate);
    const cutOffDate = new Date(migratedCutOffDate);
    
    // If the case's effective date is on or after the cutoff date, it's a migrated group
    if (caseEffectiveDate >= cutOffDate) {
        return true;
    }
    
    return false;
}

export const isUhcRenewalFlow = () => {
    const { renewals } = getReduxStoreReference().getState();
    const groupType = renewals?.renewalCaseData?.groupType;

    return isUhcRenewals()
        || (isMigratedGroup() && groupType?.toUpperCase() === 'UHC');
}